module.exports = __webpack_public_path__ + "static/caran-09dcff8d182ebf0922e9fc394334b5e1.png";